import TrackerDataTableView
from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableView/TrackerDataTableView'
import EntityDetailsMobile from '@/agilis/mobile/EntityDetailsMobile/EntityDetailsMobile.vue'
import TitlePageMobile from '@/agilis/mobile/TitlePageMobile/TitlePageMobile.vue'
import ChildrenDataTableMobile
from '@/agilis/mobile/TrackerDataTableItemChildrenMobile/TrackerDataTableItemChildrenMobile.vue'
import { computed } from 'vue'
import ComponentResolverTrackerDataTableMobile
from '@/agilis/mobile/TrackerDataTableViewMobile/ComponentResolverTrackerDataTableMobile/ComponentResolverTrackerDataTableMobile.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'TrackerDataTableViewMobile',
  mixins: [TrackerDataTableView],
  components: {
    ComponentResolverTrackerDataTableMobile,
    TitlePageMobile,
    EntityDetailsMobile,
    ChildrenDataTableMobile
  },
  data () {
    return {
      dialogSubtasks: false,
      dialogDetails: false,
      dialogOpen: false,
      componentSelected: {},
      children: [],
      items: []
    }
  },
  async created () {
    this.fetchData(this.trackerId)
    if ((this.userCanAccessFeature('subtask')) && this.trackerTypeCanHaveChildren) {
      await this.fetchDataChildren()
    }
    this.$watch(
      () => this.$store.state.mobileDataTableStore.reloadAll,
      async (newValue, oldValue) => {
        if (newValue) {
          this.fetchData(this.trackerId)
          if (this.userCanAccessFeature('subtask') && this.trackerTypeCanHaveChildren) {
            await this.fetchDataChildren()
          }
          this.$store.commit('mobileDataTableStore/setReloadAll', false)
        }
      }
    )
    this.components()
  },
  provide () {
    return {
      provideTrackerDTO: computed(() => this.trackerDTO),
      provideConfiguration: computed(() => this.configuration),
      provideSelectedContext: computed(() => this.selectedContext),
      provideJlAssertionContext: computed(() => {
        return this.jlAssertionContext
      })
    }
  },
  computed: {
    ...mapGetters({
      reload: 'mobileDataTableStore/getReloadAll',
      trackerStateMachine: 'contextStore/trackerStateMachine'
    }),
    stateLabel () {
      return this.trackerStateMachine.states.find(element => element.id === this.trackerDTO?.state)?.label || ''
    },
    computedTitle () {
      if (this.configuration?.itemTitle) {
        return this.$t(this.configuration.itemTitle, this.trackerForRendering)
      }

      return this.$t(this.trackerType?.name) + ' ' + this.trackerDTO.id
    }
  },
  methods: {

    getIcon (component) {
      return component.inline ? 'mdi-chevron-down' : 'mdi-arrow-expand'
    },
    components (items = null) {
      this.items = []
      let components = []
      const mobileViewLayout = this.configuration.mobile?.viewLayout || {}

      Object.values(mobileViewLayout).forEach(component => {
        const canAccess = this.userCanAccessFeature(component.name)
        const isSubtask = component.name === 'subtask'

        if (canAccess && (!isSubtask || this.trackerTypeCanHaveChildren)) {
          components.push(component)
        }
      })
      this.items = items || components
    },
    expandItem (item) {
      const components = this.items
      const editComponents = components.map(component => {
        if (component.id === item.id) {
          return { ...component, expanded: !item.expanded }
        }
        return component
      })
      this.components(editComponents)
    },
    async fetchDataChildren () {
      try {
        const url = this.$axios.agilisUrlTrackerChildren(
          this.applicationId,
          this.trackerTypeId,
          this.trackerId)
        const response = await this.axios.get(url, this.$axios.agilisRequestConfig(url))
        this.trackerWithChildren = response.data
        if (this.trackerWithChildren.childTrackers) {
          this.children = this.trackerWithChildren?.childTrackers?.map(c => c.tracker)
        }
      } catch (error) {
        this.notifyError(error)
      }
    },
    openDialog (component) {
      if (!component.inline) {
        this.dialogOpen = true
        this.componentSelected = component
      }
    }
  }
}
